import { useState, useEffect } from "react";
import bilAPI from "../../services/api";
import { onSessionEnded } from "../../services/session";
import setDatepickerLocale from "../setDatepickerLocale";
import { useAcademicYearsStore } from "../stores/useAcademicYearsStore";
import { useAcademicTermsStore } from "../stores/useAcademicTermsStore";

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [positions, setPositions] = useState([]);
  const [isLoading, setLoading] = useState(true);

  async function getUser() {
    try {
      const response = await bilAPI.get("/auth/me/");

      if (response?.data) {
        setUser(response.data);

        const userRoles = response.data.roles?.map((role) => {
          return role.code;
        });
        setRoles(userRoles);

        const userPositions = response.data.positions?.map((position) => {
          return position.code;
        });
        setPositions(userPositions);

        setLoading(false);
        setDatepickerLocale();
      }
    } catch {
      setLoading(false);
    }
  }

  useEffect(() => {
    async function findUser() {
      try {
        const response = await bilAPI.get("/auth/me/");

        if (response?.data) {
          setUser(response.data);

          const userRoles = response.data.roles?.map((role) => {
            return role.code;
          });
          setRoles(userRoles);

          const userPositions = response.data.positions?.map((position) => {
            return position.code;
          });
          setPositions(userPositions);

          // Fetch academic years and terms on login
          const fetchAcademicYears = useAcademicYearsStore.getState().fetchAcademicYears;
          const fetchAcademicTerms = useAcademicTermsStore.getState().fetchAcademicTerms;

          try {
            await fetchAcademicYears();
            await fetchAcademicTerms();
          } catch (error) {
            console.error("Error fetching academic data:", error);
          }

          setLoading(false);
          setDatepickerLocale();
        }
      } catch {
        setLoading(false);
      }
    }

    findUser();
  }, []);

  // A failed token refresh anywhere in the axios layer ends the session here:
  // dropping `user` is what makes ProtectedRoute redirect to /login.
  useEffect(() => onSessionEnded(() => setUser(null)), []);

  return {
    user,
    setUser,
    getUser,
    roles,
    positions,
    isLoading,
  };
}
